var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.169922,
    width: 35.9998,
    height: 36,
    rx: 17.9999,
    fill: "#23A0DC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5467_89544)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38466 17.0051C13.7534 14.7471 17.3333 13.2585 19.1246 12.5393C24.239 10.4858 25.3017 10.1291 25.9943 10.1173C26.1467 10.1147 26.4873 10.1512 26.708 10.324C26.8943 10.4699 26.9455 10.6671 26.9701 10.8054C26.9946 10.9438 27.0252 11.259 27.0009 11.5053C26.7237 14.3164 25.5245 21.1382 24.9144 24.2866C24.6562 25.6189 24.1479 26.0655 23.6558 26.1093C22.5864 26.2043 21.7743 25.427 20.7384 24.7715C19.1176 23.7459 18.2019 23.1074 16.6286 22.1065C14.8103 20.9499 15.989 20.3141 17.0252 19.2752C17.2964 19.0033 22.0085 14.8659 22.0997 14.4905C22.1111 14.4436 22.1217 14.2686 22.014 14.1762C21.9063 14.0838 21.7474 14.1154 21.6327 14.1406C21.4701 14.1762 18.8808 15.8283 13.8646 19.097C13.1296 19.5842 12.4639 19.8215 11.8675 19.8091C11.2099 19.7954 9.94504 19.4502 9.00474 19.1551C7.85143 18.7932 6.93479 18.6019 7.01461 17.9873C7.05619 17.6671 7.51287 17.3397 8.38466 17.0051Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5467_89544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "white",
    transform: "translate(7.16992 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.214eb4469375213b27dad6851c0a3c71.svg";
export { ForwardRef as ReactComponent };